import { useMutation, useQuery, useQueryClient } from "react-query";
import pdfLayoutApi, {
  PdfLayout,
  PdfLayoutResponse,
} from "../utils/api/pdfLayout";

export const pdfLayoutKey = (templateId: number) => ["pdfLayout", templateId];

export function usePdfLayout(templateId: number) {
  return useQuery<PdfLayoutResponse>(
    pdfLayoutKey(templateId),
    () => pdfLayoutApi.get(templateId),
    { refetchOnWindowFocus: false },
  );
}

export function useSavePdfLayout(templateId: number) {
  const queryClient = useQueryClient();

  return useMutation((data: PdfLayout) => pdfLayoutApi.save(templateId, data), {
    onSuccess: () => {
      queryClient.invalidateQueries(pdfLayoutKey(templateId));
      queryClient.invalidateQueries(["inspectionTemplates", templateId]);
    },
  });
}
